module.exports = __webpack_public_path__ + "img/RLaudo+ alteracao da linha.84927006.jpg";